<template>
  <div class="main-container">
    <TopMenu ref="topMenu" />
    <Alert/>
    <SideMenu
      ref="sideMenu"
      v-bind:class="{
        hideSide: !sideActive,
        districtSelected: districtSelected,
      }"
    />
    <!-- <OpacitySlider/> -->
    <Map ref="map" />
  </div>
</template>

<script>

import SideMenu from "./Menus/SideMenu/SideMenu.vue";
import TopMenu from "./Menus/TopMenu.vue";
//import { Enums } from "../data/Config/Config";
import Map from "./Maps/Map.vue";
import { EventBus } from "../data/EventBus";
import Alert from "./Menus/Alert";

export default {
  name: "Main",
  components: {
    Map,
    SideMenu,
    TopMenu,
    Alert
  },
  data: function () {
    return {};
  },
  mounted: function () {
    EventBus.$on("zoomIn", ()=>this.$refs.map.zoomToSelected());
  },
  methods: {
    toggleSide: function () {
      this.sideActive = !this.sideActive;
    },
  },
  watch: {},
  computed: {
    sideActive: {
      get: function () {
        return this.$store.getters.getSidePanelOpen;
      },
      set: function (newValue) {
        this.$store.commit("setSidePanelOpen", newValue);
      },
    },
    districtSelected: {
      get: function () {
        return Object.keys(this.$store.getters.getSelectedData).length > 0;
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-container {
  background: var(--honeydew);
}

@keyframes hide-side-anim {
  from {
    height: 100%;
    opacity: 1;
  }
  to {
    height: 100px;
    opacity: 1;
  }
}

.hideSide {
  height: 100px;
  animation-name: hide-side-anim;
  animation-duration: 0.5s;
  overflow: hidden;
}

.mb-map {
  z-index: 0;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.v-icon.v-icon {
  font-size: 36px;
}
</style>
